import React, {
  useMemo,
  useState,
  useCallback,
  useEffect,
  useRef,
} from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
  IconButton,
  LinearProgress,
  Box,
  Typography,
  Button,
} from '@material-ui/core';
import { isEmpty, isNull, difference } from 'lodash';

import { UnidataTable } from '~/components';
import { t, downloadFile } from '~/helpers';
import api from '~/services/api';
import {
  dataInRequest,
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/uploadplanilhacliente/actions';

import Dropzone from './components/Dropzone';
import PlanilhaAdm from './components/PlanilhaAdm';
import MyForm from './form';
import * as S from './styles';

function Uploadplanilhacliente() {
  const reference = useRef(null);

  const redux = useSelector((state) => state.uploadplanilhacliente);

  const [dropzoneDisabled, setDropzoneDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [dropFiles, setDropFiles] = useState([]);
  const [filesTemp, setFilesTemp] = useState([]);
  const [progress, setProgress] = useState(0);
  const [progress2, setProgress2] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [showProgressBar2, setShowProgressBar2] = useState(false);
  const [cleanList, setCleanList] = useState(false);

  const [visible, setVisible] = useState(false);
  const [params, setParams] = useState({});
  const [sending, setSending] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [toggleDisabled, setToggleDisabled] = useState(false);

  const [arquivoProcessar, setArquivoProcessar] = useState('');

  const [initials, setInitials] = useState({});

  const header = useMemo(() => [], []);

  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  function LinearProgressWithLabel(props) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.secondary">{`${Math.round(
            props.value
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }

  const onDrop = async (files) => {
    let hasError = false;
    try {
      if (!isEmpty(files[0])) {
        uploadFile(setShowProgressBar, setProgress, files[0]);
      }
    } catch (err) {
      setArquivoProcessar('');
      toast.error(err);
      hasError = true;
    } finally {
      !hasError && setCleanList(true);
    }
  };

  const uploadFile = useCallback(
    async (showProgress, loadProgress, file) => {
      try {
        showProgress(true);
        const formData = new FormData();
        formData.append('file', file);
        formData.append('path', file.path);

        const headers = {
          'Content-Type': 'multipart/form-data',
        };
        await api.post('uploadplanilhacliente/uploadvarios', formData, {
          onUploadProgress: (event) => {
            const progress = Math.round((event.loaded * 100) / event.total);
            // loadProgress(progress)
            loadProgress(50);
          },
          headers,
        });
        loadProgress(100);

        setArquivoProcessar(file.name);

        toast.success(`Arquivo ${file.name} enviado com sucesso !!`);
      } catch (err) {
        toast.error(err);
        setArquivoProcessar('');
      } finally {
        showProgress(false);
        loadProgress(0);
      }
    },
    [redux]
  );

  useEffect(() => {
    if (sending) {
      setFilesTemp(dropFiles);
      onDrop(dropFiles);
      setSending(false);
    }
  }, [sending, dropFiles]);

  useEffect(() => {
    const testeArray = !isEmpty(dropFiles) && !cleanList;
    if (testeArray) {
      setToggleDisabled(false);
    } else {
      setToggleDisabled(true);
    }
  }, [dropFiles, cleanList]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!file) {
      setMessage('Por favor, selecione um arquivo.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      const headers = {
        'Content-Type': 'multipart/form-data',
      };

      const response = await api.post(
        'uploadplanilhacliente/upload',
        formData,
        {
          onUploadProgress: (event) => {
            const progress = Math.round((event.loaded * 100) / event.total);

            // loadProgress(progress)
            // loadProgress(50)
          },
          headers,
        }
      );

      if (response.ok) {
        const result = await response.text();
        setMessage(result);
      } else {
        setMessage('Erro ao fazer upload do arquivo.');
      }
    } catch (error) {
      setMessage(`Erro na conexão: ${error.message}`);
    }
  };

  const handleOk = async () => {
    setSending(true);
  };

  const handleBaixaPlanilha = useCallback(async () => {
    const anexo =
      'FOR-SER-034 - Dados para Cadastros no SCAMAIS - Envio pelo Cliente.xlsx';

    const resp = await api.get(`uploadplanilhacliente/baixarplanilha`, {
      responseType: 'blob',
    });

    const file = new Blob([resp.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    // const file = new Blob([resp.data], { type: 'application/vnd.ms-excel' });

    const a = document.createElement('a');
    const objectUrl = window.URL.createObjectURL(file);
    a.href = objectUrl;
    a.download = anexo.split('.')[0];
    a.click();
  }, []);

  return (
    <>
      {arquivoProcessar === '' ? (
        <S.FormWrapper ref={reference} initialData={initials}>
          {toggleDisabled ? (
            <Button
              color="primary"
              variant="contained"
              type="button"
              onClick={handleBaixaPlanilha}
            >
              Baixar Planilha Abastek
            </Button>
          ) : (
            <Button
              color="primary"
              variant="contained"
              type="button"
              onClick={handleOk}
            >
              Enviar
            </Button>
          )}

          <Dropzone
            onCallback={(value) => {
              setDropFiles(value);
              setCleanList(false);
            }}
            disabled={dropzoneDisabled}
            loading={loading}
            cleanList={cleanList}
          />

          {showProgressBar && (
            <Box sx={{ width: '100%' }}>
              <Typography>Enviando Arquivo 1...</Typography>
              <LinearProgressWithLabel value={progress} />
            </Box>
          )}
        </S.FormWrapper>
      ) : (
        <PlanilhaAdm
          arquivoProcessar={arquivoProcessar}
          setArquivoProcessar={setArquivoProcessar}
        />
      )}
    </>
  );
}

export default Uploadplanilhacliente;
